import React, { useState, useEffect } from 'react'
import { PieChartOutlined, CaretDownOutlined, logo, sidebaruser, MdLogout, favicon, homepage } from '../../Utils/imports';
import { Card, Menu, Popconfirm } from 'antd';
import "./Sidebar.css"
import { pageRoutes } from '../../Routing/pageRoutes';
import { useNavigate } from 'react-router-dom';
import { dashboardic, lineopic, integration, plantsetting, lineBoard, trenddown, tasksquare, setting, linePer, linesetting, documenttext, lineLevel } from "../../Utils/imports"
import { SidebarVar } from '../../Utils/variables';
import { disconnect } from '../../Libraries/socket';
import {
    checkAccess,
    controlAccess,
    extractRoles,
  } from "../../API-Interaction/apiServices/roles.api";
  import { useDispatch, useSelector } from 'react-redux';
  import { changeKey } from "../../Redux/features/plant.slice";
  import { sidebarKeys, getIcons } from '../../Utils/constants';
import BasicModal from '../Modals/BasicModal/BasicModal';
import ButtonComp from '../ButtonComp/ButtonComp';
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarRightCollapse } from 'react-icons/tb';
import { getFromLocalStorage, isSuperAdminByEmail } from '../../Helpers/helpers';

const { user_name, user_email } = SidebarVar;


function Sidebar(props) {
    const { current } = useSelector(state => state.plant)
    const dispatch = useDispatch()
    let { collapsed } = props
    let { username } = getFromLocalStorage('user')
    const navigate = useNavigate();

    const menuItems = [
        {
            key: '1',
            icon: <img className="sidebarMenuIcon" src={dashboardic} />,
            label: 'Dashboards',
            onClick: () => handleNavigation(1, pageRoutes.dashboard)
        },
        // {
        //     key: '2',
        //     icon: <img className="sidebarMenuIcon" src={tasksquare} />,
        //     label: 'Plant Averages View',
        //     onClick: () => { }
        // },
        {
            key: '3',
            icon: <img className="sidebarMenuIcon" src={linePer} />,
            label: 'Line Perf Monitor',
            onClick: () => handleNavigation(1, pageRoutes.oee.linePerformanceMonitor)
        },
        // {
        //     key: '4',
        //     icon: <img className="sidebarMenuIcon" src={lineLevel} />,
        //     label: 'Line Level Board',
        //     onClick: () => { }
        // },
        {
            key: '5',
            icon: <img className="sidebarMenuIcon" src={lineBoard} />,
            label: 'Line Board',
            onClick: () => handleNavigation(1, pageRoutes.lineBoard)
        },
        // {
        //     key: '7',
        //     icon: <img className="sidebarMenuIcon" src={setting} />,
        //     label: 'Merge Dashboard',
        //     onClick: () => { }
        // },
        {
            key: '8',
            icon: <img className="sidebarMenuIcon" src={lineopic} />,
            label: 'Line Operator',
            onClick: () => handleNavigation(2, pageRoutes.lineOperator)
        },
      
    ]

if (isSuperAdminByEmail(username)) {
    menuItems.push(
        {
            key: '0',
            icon: <img className="sidebarMenuIcon" src={homepage} />,
            label: 'Home',
            onClick: () => handleNavigation(1, pageRoutes.oee.homepage)
        },

    // {
    //     key: '1',
    //     icon: <img className="sidebarMenuIcon" src={dashboardic} />,
    //     label: 'Dashboards',
    //     onClick: () => handleNavigation(1, pageRoutes.dashboard)
    // },
    {
        key: '2',
        icon: <img className="sidebarMenuIcon" src={tasksquare} />,
        label: 'Plant Averages View',
        onClick: () => { }
    },
    {
        key: '3',
        icon: <img className="sidebarMenuIcon" src={documenttext} />,
        label: 'Line Perf Monitor',
        onClick: () => handleNavigation(1, pageRoutes.oee.linePerformanceMonitor)
    },
    // {
    //     key: '4',
    //     icon: <img className="sidebarMenuIcon" src={lineBoard} />,
    //     label: 'Line Level Board',
    //     onClick: () => handleNavigation(4, pageRoutes.LineLevelBoard)
    // },
    {
        key: '5',
        icon: <img className="sidebarMenuIcon" src={lineBoard} />,
        label: 'Line Board',
        onClick: () => handleNavigation(1, pageRoutes.lineBoard)
    },
    {
        key: '6',
        icon: <img className="sidebarMenuIcon" src={setting} />,
        label: 'Maintanence KPIs',
        onClick: () => { }
    },
    {
        key: '7',
        icon: <img className="sidebarMenuIcon" src={setting} />,
        label: 'Merge Dashboard',
        onClick: () => { }
    },
    // {
    //     key: '8',
    //     icon: <img className="sidebarMenuIcon" src={lineopic} />,
    //     label: 'Line Operator',
    //     onClick: () => handleNavigation(2, pageRoutes.lineOperator)
    // },
    {
        key: '9',
        icon: <img className="sidebarMenuIcon" src={trenddown} />,
        label: 'Downtime Logs',
        onClick: () => handleNavigation(5, pageRoutes.downtimeLog)

    },
    {
        key: '10',
        icon: <img className="sidebarMenuIcon" src={linesetting} />,
        label: 'Line Settings',
        onClick: () => handleNavigation(6, pageRoutes.lineSettings)
    },
    {
        key: '11',
        icon: <img className="sidebarMenuIcon" src={plantsetting} />,
        label: 'Plant Settings',
        onClick: () => handleNavigation(5, pageRoutes.plantSettings)
    },
    {
        key: '12',
        icon: <img className="sidebarMenuIcon" src={integration} />,
        label: 'Integrations',
        onClick: () => handleNavigation(1, pageRoutes.integrations)
    },
    {
        key: '13',
        icon: <img className="sidebarMenuIcon" src={documenttext} />,
        label: 'Audit Trails',
        onClick: () => handleNavigation(1, pageRoutes.AuditTrail)
    },
    );
}

menuItems.sort((a, b) => parseInt(a.key) - parseInt(b.key));

    const [modalStates, setModalStates] = useState({})

    const handleModal = (task, type) => {
        if (task === 'open')
            setModalStates({ ...modalStates, [type]: true })
        if (task === 'close')
            setModalStates({ ...modalStates, [type]: false })
    }

    const customNavigation = (route, page) => {
        dispatch(changeKey({ key: "sideKey", data: page }));
        navigate(route);
      };
    

    useEffect(() => {
        current?.sideOptions &&
          checkAccess(customNavigation, current, props.sideKey);
      }, [current?.sideOptions]);

      const handleNavigation = (key) =>
    customNavigation(sidebarKeys[key].route, key);

    const LogoutModalData = (
        <div>
            <h4 style={{ textTransform: "uppercase", fontWeight: "bold" }}>Are you sure you want to logout?</h4>
        </div>
    )

    return (
        <div className='sidebar_main_cont' style={{ width: `${!collapsed.state ? "200px" : "80px"}` }}>
            <div>
                {/* <div className='sidebar_logo'>
                    <img src={favicon} style={{ width: "30px", marginLeft: `${collapsed.state ? "4px" : ""}` }} />
                    {!collapsed.state && <img src={logo} />}
                </div> */}
                <Menu
          defaultSelectedKeys={[`${props.sideKey}`]}
          selectedKeys={[`${current?.sideKey || props.sideKey}`]}
          mode="inline"
          theme="light"
          items={getIcons(current?.sideOptions)}
          onClick={(e) => handleNavigation(e.key)}
          className="Sidebar_menuItem"
        />

            </div>
            <div className={`${collapsed.state ? "sidebar_user_collapsed" : "sidebar_user"} `} >
                <div className='dflex alignCenter justifyCenter gap10'>
                    <div>
                        {collapsed.state ? <TbLayoutSidebarRightCollapse style={{ marginBottom: "-4px", fontSize: "18px", color: "#909AB4", cursor: "pointer" }} onClick={() => collapsed.setState(!collapsed.state)} /> : <TbLayoutSidebarLeftCollapse style={{ marginBottom: "-4px", fontSize: "18px", color: "#909AB4", cursor: "pointer" }} onClick={() => collapsed.setState(!collapsed.state)} />}
                    </div>
                    <div className='sidebarUserLogo'>
                        {!collapsed.state && <div className='sidebar_user_inner ' onClick={() => { handleModal('open', 1) }}>
                            <p>{getFromLocalStorage('user')?.username}</p>
                        </div>}
                        <MdLogout className="" onClick={() => { handleModal('open', 1) }} />
                    </div>
                </div>

                <BasicModal id="1" title="Logout" children={LogoutModalData} btn1Text="Yes" btn2Text="No" open={modalStates['1'] || false}
                    handleOK={() => {
                        localStorage.clear()
                        disconnect()
                        navigate(pageRoutes.login)
                    }}
                    handleCancel={() => handleModal('close', 1)}
                    loading={false}
                />
            </div>
        </div>
    )
}

export default Sidebar